import React from 'react';
import { features } from 'configs';
import { PropTypes } from 'prop-types';

import { FaShare } from 'react-icons/fa';

import './SearchArea.css';
import { useNewConsentModalContext } from 'pages/SharePage/Context/NewConsentModalContext';
import { useUserContext } from 'store';

export function SearchArea({ setSearchFilter }) {
  const [user] = useUserContext();
  const { newConsentModalState, setNewConsentModalState } = useNewConsentModalContext();
  return (
    <div className="topArea">
      <div className="searchArea-topContent">
        <p className="pageTitle"> Compartilhamentos </p>
        {
          features.granted
          && (
          <button className="newConsentButton" onClick={() => setNewConsentModalState({ ...newConsentModalState, isOpen: true, subjectId: user.cpf })}>
            <FaShare className="share" />
            Novo consentimento
          </button>
          )
        }

      </div>
      <div>
        <p className="labelSearch"> Pesquisar por nome,CPF, data,estabelecimento </p>
        <input className="inputSearch" onChange={(e) => setSearchFilter(e.target.value)} type="text" placeholder="Digite o nome, CPF, data ou estabelecimento" />
        <button className="searchButton" type="submit">
          Pesquisar
        </button>
      </div>

    </div>
  );
}

SearchArea.propTypes = {
  setSearchFilter: PropTypes.element.isRequired,
};
